import { CircularProgress, TextField } from "@mui/material";
import { createContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootState } from "../app/store";
import { getAllMyDiaryEntires } from "../features/Diary/DiarySlice";
import Diary from "../features/Diary/interfaces/IDiary";
import DiaryCalendar from "./DiaryCalendar";
import "../styles/components/diary-entries.scss";
import DiaryEntryTable from "./DiaryEntryTable";
import useWindowDimensions from "../utils/useWindowDimensions";

interface test {
  meta: any[];
  payload: Diary[];
  type: string;
}

const DiaryEntries = () => {
  const dispatch = useDispatch();
  const {} = useSelector((state: RootState) => state.diary);

  const [diaryEntries, setDiaryEntries] = useState<Diary[]>([]);
  const { width, height } = useWindowDimensions();
  const { isDiaryFetching } = useSelector((state: RootState) => state.diary);

  useEffect(() => {
    async function dispatchGetAllMyDiaryEntries() {
      const result = (await dispatch(getAllMyDiaryEntires())) as any;
      setDiaryEntries(result?.payload);
    }
    dispatchGetAllMyDiaryEntries();
  }, []);

  return (
    <>
      {!isDiaryFetching ? (
        <div>
          {diaryEntries.length > 0 ? (
            <div>
              {width > 599 ? (
                <>
                  <h1 style={{ textAlign: "center" }}>Diary Calender</h1>
                  <DiaryCalendar diaryEntries={diaryEntries} />
                </>
              ) : (
                <></>
              )}
              <DiaryEntryTable diaryEntries={diaryEntries} />
            </div>
          ) : (
            <h1 style={{ textAlign: "center" }}>No entries found!</h1>
          )}
        </div>
      ) : (
        <div className="loading-first">
          <CircularProgress />
        </div>
      )}
    </>
  );
};
export default DiaryEntries;
